<template>
  <div class="new_navigation">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      :class="drawer ? 'drawer-expanded' : 'drawer-close'"
      app
      v-if=" (getUserType() === 'Admin' && getUserInfoType() !== 'Admin') || getUserType()=='Counter'||getUserType()=='Counter_offline'|| getUserType()=='Booking_office'|| getUserType()=='CounterPrinter'">
      <v-list dense class="white new_navigation__container--drawer">
        <template v-if="getUserType() == 'Booking_office'">

        </template>

        <template v-else-if="getUserType() == 'CounterPrinter'">

        </template>

        <template v-else-if="getUserType() == 'Counter'">
        </template>
        <template v-else>
          <template v-for="(item, i) in items">
            <v-subheader v-if="item.section_title" :key="item.section_title"
                         class="new_navigation__toolbar_options--section_header"
                         :style="{backgroundColor: item.header_color}">{{ item.section_title }}
            </v-subheader>
            <v-list-group
              sub-group
              v-if="item.dropdown"
              :key="i"
              v-model="item.selected"
              :class="{ 'new_navigation__toolbar_options--inactive_simple_item' : !item.active }">
              <template v-slot:activator>
                <v-list-tile-action class="new_navigation__toolbar_options--item_icon">
                  <component :is="item.component"></component>
                </v-list-tile-action>
                <v-list-tile :title="item.title" class="new_navigation__toolbar_options--item_title">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
                <div class="v-list__group__header__append-icon">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">keyboard_arrow_down</i>
                </div>
              </template>
              <v-list-tile v-for="(subItem, i) in item.sub_items" :key="i"
                           class="new_navigation__toolbar_options--dropdown_item"
                           @click="changeRoute(subItem, subItem.route)"
                           :class="[{ 'new_navigation__toolbar_options--item_selected' : subItem.selected }, { 'new_navigation__toolbar_options--inactive_simple_item' : item.active && !subItem.active }]">
                <v-list-tile-content :title="subItem.title">
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <v-list v-else :key="item" class="new_navigation__toolbar_options--simple_item"
                    :class="{ 'new_navigation__toolbar_options--inactive_simple_item' : !item.active }">
              <v-list-tile @click="changeRoute(item, item.route)"
                           :class="{ 'new_navigation__toolbar_options--item_selected' : item.selected }"
                           :title="item.title">
                <v-list-tile-action class="new_navigation__toolbar_options--item_icon">
                  <component :is="item.component"></component>
                </v-list-tile-action>

                <v-list-tile>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list-tile>
            </v-list>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      color="white"
      app
      fixed
      clipped-left
    >
      <div class="new_navigation__container--toolbar">
        <div class="new_navigation__toolbar_options--menu">
          <img
            @click="switchDrawer()" v-if="!(getUserType() === 'Admin' && getUserInfoType() === 'Admin')"
            src="../../assets/img/menu.svg"
            class="new_navigation__container--toggle"
          >
          <span
            class="title ml-3 mr-5 new_navigation__text--title"
          >
                    <img
                      v-if="this.getCompany().personalize.app_logo != '' && this.getCompany().personalize.app_logo != null && this.getCompany().personalize.app_logo != undefined "
                      @click="switchDrawer()"
                      style="max-width: 188px"
                      :src="this.getCompany().personalize.app_logo.url"
                    >
                    <img
                      v-else
                      @click="drawer = !drawer"
                      style="max-width: 188px"
                      src="../../assets/img/logo.png"
                    >
                    </span>
        </div>
        <v-hover>
          <v-toolbar-items>
            <v-menu v-if="!$vuetify.breakpoint.xs">
              <template v-slot:activator="{ on }">
                <div
                  class="toolbar_dropdown"
                  v-on="on"
                >
                  <v-flex>
                    <div>
                      Hola, <span class="toolbar_dropdown--title">
                            {{ getNameUser() }}
                            </span>
                    </div>
                    <label class="toolbar_dropdown--email">
                      {{ getEmailUser() }}
                    </label>
                  </v-flex>
                  <img style="max-width: 20px" src="../../assets/img/arrow-down.svg" class="toolbar_dropdown--icon">
                </div>
              </template>
              <v-list>
                <v-list-tile @click="logout()">
                  <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <button @click="logout()" class="button" v-else>Cerrar Sesión</button>
          </v-toolbar-items>
        </v-hover>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
import user from './navigation/User'
import offline from 'v-offline';
import NavigationOption from './OptionNavigationDrawer.vue'
import invitations_services from "../../services/invitations_services";
import { error } from 'shelljs';

export default {
  data: () => ({
    drawer: false,
    selected_item: '',
    selected_subitem: '',
    current_name: 'Dashboard',
    charged: false,
    items: [],
    validatorTimer: null,
  }),
  props: {},
  watch: {
    $route(to, from) {
      this.show = false;
      this.select_menu_item(to, from)
    }
  },
  beforeMount() {
    this.items = [
      {
        title: 'Página Principal',
        active: true,
        component: 'home-icon',
        dropdown: false,
        selected: false,
        route: 'main_menu_page',
        sub_items: []
      },
      {
        title: 'Accesos',
        section_title: 'Seguridad',
        header_color: '#1565C0',
        active: this.enabledItem(this.getCompany().access),
        component: 'access',
        dropdown: true,
        selected: false,
        sub_items: [
          {
            id: 2,
            title: 'Invitaciones',
            route: 'invitations_index',
            selected: false,
            active: true
          }
        ]
      },
    ]
  },
  components: {
    user: user,
    offline,
    NavigationOption
  },
  methods: {
    logout() {
      localStorage.clear();
      sessionStorage.clear();
      if (!window.eel) {
        window.location = '/';
      } else {
        window.eel.close_program()
        window.close();
        window.location = '/';
      }
    },
    switchDrawer() {
      console.log(this.getUserType(), this.getUserInfoType() === 'Admin');

      if (this.getUserType() === 'Admin' && this.getUserInfoType() === 'Admin') {
        return;
      }
      this.drawer = !this.drawer;
    },
    changeRoute(item, link) {
      this.selected_item = item.title;
      this.selected_subitem = item.title;
      if (link === 'import_employees') {
        this.items[3].sub_items[1].active = this.getCompany().has_booking_locations
        item.active = this.getCompany().has_booking_locations
      }
      this.$router.push({name: item.active ? link : ''})
    },
    select_menu_item(to, from) {
      let previous_items = [];
      this.items.map(function (value, key) {
        if (value.route && value.route.toString() === from.name.toString()) {
          previous_items.push(key)
        }
      });
      let previous_sub_items = []
      this.items.map(function (value, item_key) {
        let sub_items = []
        value.sub_items.map(function (value, sub_item_key) {
          if (value.route.toString() === from.name.toString()) {
            if (!previous_items.includes(item_key)) {
              previous_items.push(item_key)
            }
            sub_items.push(sub_item_key)
          }
        })
        if (sub_items.length > 0) {
          sub_items.map(function (sub_item) {
            previous_sub_items.push({item_index: item_key, sub_item: sub_item})
          })
        }
      });
      previous_items = previous_items.filter(e => e !== -1)
      if (previous_items.length > 0 && previous_sub_items.length > 0) {
        previous_sub_items.forEach((subItem) => {
          if (this.items[subItem.item_index].sub_items.length > 0) {
            this.items[subItem.item_index].selected = false
            this.items[subItem.item_index].sub_items[subItem.sub_item].selected = false
          } else {
            this.items[subItem.item_index].selected = false
          }
        })
      } else if (previous_items.length > 0 && previous_sub_items.length === 0) {
        previous_items.forEach((index) => {
          this.items[index].selected = false
        })
      }

      let current_items = [];
      this.items.map(function (value, key) {
        if (value.route && value.route.toString() === to.name.toString()) {
          current_items.push(key)
        }
      });
      let current_sub_items = []
      this.items.map(function (value, item_key) {
        let sub_items = []
        value.sub_items.map(function (value, sub_item_key) {
          if (value.route.toString() === to.name.toString()) {
            if (!current_items.includes(item_key)) {
              current_items.push(item_key)
            }
            sub_items.push(sub_item_key)
          }
        })
        if (sub_items.length > 0) {
          sub_items.map(function (sub_item) {
            current_sub_items.push({item_index: item_key, current_sub_item: sub_item})
          })
        }
      });
      current_items = current_items.filter(e => e !== -1)
      if (current_items.length > 0 && current_sub_items.length > 0) {
        current_sub_items.forEach((subItem) => {
          if (this.items[subItem.item_index].sub_items.length > 0) {
            this.items[subItem.item_index].selected = true
            this.items[subItem.item_index].sub_items[subItem.current_sub_item].selected = true
          } else {
            this.items[subItem.item_index].selected = true
          }
        })
      } else if (current_items.length > 0 && current_sub_items.length === 0) {
        current_items.forEach((index) => {
          this.items[index].selected = true
        })
      }
    },
    enabledItem(company_object) {
      return Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0;
    },
    async validatePendingEvents() {
      console.log('Validator started')
      try {
        const response = invitations_services.validatePendingInvitations({
          id: this.getUserId(),
          status: 'active',
        });
        if (response.has_invitations === true) {
          if (!("Notification" in window)) {
            console.warn("Las notificaciones no son compatibles con este navegador.");
            return;
          }
          if (Notification.permission === "granted") {
            new Notification("Tienes invitaciones pendientes", {
              body: "Por favor, revisa tus invitaciones.",
              icon: "../../assets/img/logo.png"
            });
          } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(permission => {
              if (permission === "granted") {
                new Notification("Tienes invitaciones pendientes", {
                  body: "Por favor, revisa tus invitaciones.",
                  icon: "../../assets/img/logo.png"
                });
              }
            });
          }
        }
      } catch (e) {
        console.error(e);

      }
    }
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("resize", this.openSidebar);
      this.validatorTimer = setInterval(async () => {
        await this.validatePendingEvents();
      }, 300000); //5 minutes
    }, 800);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.openSidebar);
    clearInterval(this.validatorTimer);
  }
}
</script>
<style>
.drawer-expanded {
  min-width: 16.75% !important;
  margin-left: 1.5% !important;
  background: rgb(247, 247, 249) !important;
  padding-right: 0.5%;
  padding-bottom: 2%;
}

.drawer-close {
  min-width: 10.75% !important;
  margin-left: 0% !important;
}

.button {
  background: #3692fc;
  padding: 1rem;
  cursor: pointer;
  color: white;
}

.button:hover {
  background: #2586fc;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NewNavigation.vue